import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Review your changes", -1)
const _hoisted_2 = { class: "q-pa-md" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" ➡️ Slide to confirm ➡️ ")

export interface DiffItem { Name: string, Old: string, New: string }


export default /*#__PURE__*/_defineComponent({
  __name: 'AttributesUpdatePrompt',
  props: { diff: Array },
  setup(__props) {

const props = __props



const columns: Array<any> = [
  { name: 'attribute', required: true, label: 'Attribute', align: 'left', field: (t: any) => { console.log('adzxc'); return t.Name } },
  { name: 'old', required: true, label: 'Old', align: 'left', field: (r: any) => { return r.Old } },
  { name: 'new', align: 'center', label: 'New', field: (r: any) => r.New }
]

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_slide_item = _resolveComponent("q-slide-item")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_q_table, {
                  "hide-bottom": "",
                  rows: props.diff,
                  columns: columns,
                  "row-key": "attribute"
                }, null, 8, ["rows"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_slide_item, {
            onLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('ok', { hasSlid: true })))
          }, {
            left: _withCtx(() => [
              _createVNode(_component_q_icon, { name: "done" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_q_item, { class: "bg-secondary" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})